/* tslint:disable */
/* eslint-disable */
/**
 * Product Storage API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poizon-api.com/api/product-storage/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProductByExternalIdResponseDto } from '../models';
// @ts-ignore
import type { ProductDetailResponseDto } from '../models';
// @ts-ignore
import type { ProductsResponseV2WithPaginationDto } from '../models';
// @ts-ignore
import type { ProductsResponseWithPaginationDto } from '../models';
// @ts-ignore
import type { SearchProductsCountResponseDto } from '../models';
/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение детальной информации о продукте
         * @param {number} [id] 
         * @param {string} [article] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerGetProductDetail: async (id?: number, article?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (article !== undefined) {
                localVarQueryParameter['article'] = article;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поиск продукта по id внешнего источника
         * @param {string} externalId Id товара во внешней системе
         * @param {ProductControllerGetProductDetailsByExternalIdSourceEnum} source Source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerGetProductDetailsByExternalId: async (externalId: string, source: ProductControllerGetProductDetailsByExternalIdSourceEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('productControllerGetProductDetailsByExternalId', 'externalId', externalId)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('productControllerGetProductDetailsByExternalId', 'source', source)
            const localVarPath = `/product/external`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (externalId !== undefined) {
                localVarQueryParameter['externalId'] = externalId;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поиск товаров по фильтрам
         * @param {string} [query] Search query string
         * @param {Array<number>} [categories] Category ID or array of category IDs
         * @param {Array<number>} [brands] Array of brand IDs
         * @param {Array<number>} [models] Array of model IDs
         * @param {Array<ProductControllerSearchGendersEnum>} [genders] Array of genders
         * @param {number} [priceMin] Minimum price
         * @param {number} [priceMax] Maximum price
         * @param {number} [ratingMin] Minimum rating
         * @param {ProductControllerSearchCurrencyEnum} [currency] Целевая валюта для конвертации цен
         * @param {boolean} [includeCustom] Include Custom\&#39;s
         * @param {number} [selectionId] 
         * @param {Array<number>} [excludeSelectionIds] Array of product selection IDs to exclude products from search results
         * @param {Array<ProductControllerSearchSourcesEnum>} [sources] Array of sources
         * @param {number} [limit] Limit results
         * @param {string} [cursor] Last elemend id for pagination
         * @param {ProductControllerSearchSortByEnum} [sortBy] Sorting method. release_desc/release_asc — по дате релиза; товары без даты всегда в конце выдачи
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerSearch: async (query?: string, categories?: Array<number>, brands?: Array<number>, models?: Array<number>, genders?: Array<ProductControllerSearchGendersEnum>, priceMin?: number, priceMax?: number, ratingMin?: number, currency?: ProductControllerSearchCurrencyEnum, includeCustom?: boolean, selectionId?: number, excludeSelectionIds?: Array<number>, sources?: Array<ProductControllerSearchSourcesEnum>, limit?: number, cursor?: string, sortBy?: ProductControllerSearchSortByEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }

            if (brands) {
                localVarQueryParameter['brands'] = brands;
            }

            if (models) {
                localVarQueryParameter['models'] = models;
            }

            if (genders) {
                localVarQueryParameter['genders'] = genders;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (ratingMin !== undefined) {
                localVarQueryParameter['ratingMin'] = ratingMin;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (includeCustom !== undefined) {
                localVarQueryParameter['includeCustom'] = includeCustom;
            }

            if (selectionId !== undefined) {
                localVarQueryParameter['selectionId'] = selectionId;
            }

            if (excludeSelectionIds) {
                localVarQueryParameter['excludeSelectionIds'] = excludeSelectionIds;
            }

            if (sources) {
                localVarQueryParameter['sources'] = sources;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Количество товаров по фильтрам
         * @param {string} [query] Search query string
         * @param {Array<number>} [categories] Category ID or array of category IDs
         * @param {Array<number>} [brands] Array of brand IDs
         * @param {Array<number>} [models] Array of model IDs
         * @param {Array<ProductControllerSearchCountGendersEnum>} [genders] Array of genders
         * @param {number} [priceMin] Minimum price
         * @param {number} [priceMax] Maximum price
         * @param {number} [ratingMin] Minimum rating
         * @param {ProductControllerSearchCountCurrencyEnum} [currency] Целевая валюта для конвертации цен
         * @param {boolean} [includeCustom] Include Custom\&#39;s
         * @param {number} [selectionId] 
         * @param {Array<number>} [excludeSelectionIds] Array of product selection IDs to exclude products from search results
         * @param {Array<ProductControllerSearchCountSourcesEnum>} [sources] Array of sources
         * @param {number} [limit] Limit results
         * @param {string} [cursor] Last elemend id for pagination
         * @param {ProductControllerSearchCountSortByEnum} [sortBy] Sorting method. release_desc/release_asc — по дате релиза; товары без даты всегда в конце выдачи
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerSearchCount: async (query?: string, categories?: Array<number>, brands?: Array<number>, models?: Array<number>, genders?: Array<ProductControllerSearchCountGendersEnum>, priceMin?: number, priceMax?: number, ratingMin?: number, currency?: ProductControllerSearchCountCurrencyEnum, includeCustom?: boolean, selectionId?: number, excludeSelectionIds?: Array<number>, sources?: Array<ProductControllerSearchCountSourcesEnum>, limit?: number, cursor?: string, sortBy?: ProductControllerSearchCountSortByEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product/search/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }

            if (brands) {
                localVarQueryParameter['brands'] = brands;
            }

            if (models) {
                localVarQueryParameter['models'] = models;
            }

            if (genders) {
                localVarQueryParameter['genders'] = genders;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (ratingMin !== undefined) {
                localVarQueryParameter['ratingMin'] = ratingMin;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (includeCustom !== undefined) {
                localVarQueryParameter['includeCustom'] = includeCustom;
            }

            if (selectionId !== undefined) {
                localVarQueryParameter['selectionId'] = selectionId;
            }

            if (excludeSelectionIds) {
                localVarQueryParameter['excludeSelectionIds'] = excludeSelectionIds;
            }

            if (sources) {
                localVarQueryParameter['sources'] = sources;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Поиск товаров по фильтрам V2
         * @param {string} [query] Search query string
         * @param {Array<number>} [categories] Category ID or array of category IDs
         * @param {Array<number>} [brands] Array of brand IDs
         * @param {Array<number>} [models] Array of model IDs
         * @param {Array<ProductControllerSearchV2GendersEnum>} [genders] Array of genders
         * @param {number} [priceMin] Minimum price
         * @param {number} [priceMax] Maximum price
         * @param {number} [ratingMin] Minimum rating
         * @param {ProductControllerSearchV2CurrencyEnum} [currency] Целевая валюта для конвертации цен
         * @param {boolean} [includeCustom] Include Custom\&#39;s
         * @param {number} [selectionId] 
         * @param {Array<number>} [excludeSelectionIds] Array of product selection IDs to exclude products from search results
         * @param {Array<ProductControllerSearchV2SourcesEnum>} [sources] Array of sources
         * @param {number} [limit] Limit results
         * @param {string} [cursor] Last elemend id for pagination
         * @param {ProductControllerSearchV2SortByEnum} [sortBy] Sorting method. release_desc/release_asc — по дате релиза; товары без даты всегда в конце выдачи
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerSearchV2: async (query?: string, categories?: Array<number>, brands?: Array<number>, models?: Array<number>, genders?: Array<ProductControllerSearchV2GendersEnum>, priceMin?: number, priceMax?: number, ratingMin?: number, currency?: ProductControllerSearchV2CurrencyEnum, includeCustom?: boolean, selectionId?: number, excludeSelectionIds?: Array<number>, sources?: Array<ProductControllerSearchV2SourcesEnum>, limit?: number, cursor?: string, sortBy?: ProductControllerSearchV2SortByEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product/searchV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }

            if (brands) {
                localVarQueryParameter['brands'] = brands;
            }

            if (models) {
                localVarQueryParameter['models'] = models;
            }

            if (genders) {
                localVarQueryParameter['genders'] = genders;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (ratingMin !== undefined) {
                localVarQueryParameter['ratingMin'] = ratingMin;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (includeCustom !== undefined) {
                localVarQueryParameter['includeCustom'] = includeCustom;
            }

            if (selectionId !== undefined) {
                localVarQueryParameter['selectionId'] = selectionId;
            }

            if (excludeSelectionIds) {
                localVarQueryParameter['excludeSelectionIds'] = excludeSelectionIds;
            }

            if (sources) {
                localVarQueryParameter['sources'] = sources;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение детальной информации о продукте
         * @param {number} [id] 
         * @param {string} [article] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerGetProductDetail(id?: number, article?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDetailResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerGetProductDetail(id, article, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.productControllerGetProductDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поиск продукта по id внешнего источника
         * @param {string} externalId Id товара во внешней системе
         * @param {ProductControllerGetProductDetailsByExternalIdSourceEnum} source Source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerGetProductDetailsByExternalId(externalId: string, source: ProductControllerGetProductDetailsByExternalIdSourceEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductByExternalIdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerGetProductDetailsByExternalId(externalId, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.productControllerGetProductDetailsByExternalId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поиск товаров по фильтрам
         * @param {string} [query] Search query string
         * @param {Array<number>} [categories] Category ID or array of category IDs
         * @param {Array<number>} [brands] Array of brand IDs
         * @param {Array<number>} [models] Array of model IDs
         * @param {Array<ProductControllerSearchGendersEnum>} [genders] Array of genders
         * @param {number} [priceMin] Minimum price
         * @param {number} [priceMax] Maximum price
         * @param {number} [ratingMin] Minimum rating
         * @param {ProductControllerSearchCurrencyEnum} [currency] Целевая валюта для конвертации цен
         * @param {boolean} [includeCustom] Include Custom\&#39;s
         * @param {number} [selectionId] 
         * @param {Array<number>} [excludeSelectionIds] Array of product selection IDs to exclude products from search results
         * @param {Array<ProductControllerSearchSourcesEnum>} [sources] Array of sources
         * @param {number} [limit] Limit results
         * @param {string} [cursor] Last elemend id for pagination
         * @param {ProductControllerSearchSortByEnum} [sortBy] Sorting method. release_desc/release_asc — по дате релиза; товары без даты всегда в конце выдачи
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerSearch(query?: string, categories?: Array<number>, brands?: Array<number>, models?: Array<number>, genders?: Array<ProductControllerSearchGendersEnum>, priceMin?: number, priceMax?: number, ratingMin?: number, currency?: ProductControllerSearchCurrencyEnum, includeCustom?: boolean, selectionId?: number, excludeSelectionIds?: Array<number>, sources?: Array<ProductControllerSearchSourcesEnum>, limit?: number, cursor?: string, sortBy?: ProductControllerSearchSortByEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsResponseWithPaginationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerSearch(query, categories, brands, models, genders, priceMin, priceMax, ratingMin, currency, includeCustom, selectionId, excludeSelectionIds, sources, limit, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.productControllerSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Количество товаров по фильтрам
         * @param {string} [query] Search query string
         * @param {Array<number>} [categories] Category ID or array of category IDs
         * @param {Array<number>} [brands] Array of brand IDs
         * @param {Array<number>} [models] Array of model IDs
         * @param {Array<ProductControllerSearchCountGendersEnum>} [genders] Array of genders
         * @param {number} [priceMin] Minimum price
         * @param {number} [priceMax] Maximum price
         * @param {number} [ratingMin] Minimum rating
         * @param {ProductControllerSearchCountCurrencyEnum} [currency] Целевая валюта для конвертации цен
         * @param {boolean} [includeCustom] Include Custom\&#39;s
         * @param {number} [selectionId] 
         * @param {Array<number>} [excludeSelectionIds] Array of product selection IDs to exclude products from search results
         * @param {Array<ProductControllerSearchCountSourcesEnum>} [sources] Array of sources
         * @param {number} [limit] Limit results
         * @param {string} [cursor] Last elemend id for pagination
         * @param {ProductControllerSearchCountSortByEnum} [sortBy] Sorting method. release_desc/release_asc — по дате релиза; товары без даты всегда в конце выдачи
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerSearchCount(query?: string, categories?: Array<number>, brands?: Array<number>, models?: Array<number>, genders?: Array<ProductControllerSearchCountGendersEnum>, priceMin?: number, priceMax?: number, ratingMin?: number, currency?: ProductControllerSearchCountCurrencyEnum, includeCustom?: boolean, selectionId?: number, excludeSelectionIds?: Array<number>, sources?: Array<ProductControllerSearchCountSourcesEnum>, limit?: number, cursor?: string, sortBy?: ProductControllerSearchCountSortByEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchProductsCountResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerSearchCount(query, categories, brands, models, genders, priceMin, priceMax, ratingMin, currency, includeCustom, selectionId, excludeSelectionIds, sources, limit, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.productControllerSearchCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Поиск товаров по фильтрам V2
         * @param {string} [query] Search query string
         * @param {Array<number>} [categories] Category ID or array of category IDs
         * @param {Array<number>} [brands] Array of brand IDs
         * @param {Array<number>} [models] Array of model IDs
         * @param {Array<ProductControllerSearchV2GendersEnum>} [genders] Array of genders
         * @param {number} [priceMin] Minimum price
         * @param {number} [priceMax] Maximum price
         * @param {number} [ratingMin] Minimum rating
         * @param {ProductControllerSearchV2CurrencyEnum} [currency] Целевая валюта для конвертации цен
         * @param {boolean} [includeCustom] Include Custom\&#39;s
         * @param {number} [selectionId] 
         * @param {Array<number>} [excludeSelectionIds] Array of product selection IDs to exclude products from search results
         * @param {Array<ProductControllerSearchV2SourcesEnum>} [sources] Array of sources
         * @param {number} [limit] Limit results
         * @param {string} [cursor] Last elemend id for pagination
         * @param {ProductControllerSearchV2SortByEnum} [sortBy] Sorting method. release_desc/release_asc — по дате релиза; товары без даты всегда в конце выдачи
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerSearchV2(query?: string, categories?: Array<number>, brands?: Array<number>, models?: Array<number>, genders?: Array<ProductControllerSearchV2GendersEnum>, priceMin?: number, priceMax?: number, ratingMin?: number, currency?: ProductControllerSearchV2CurrencyEnum, includeCustom?: boolean, selectionId?: number, excludeSelectionIds?: Array<number>, sources?: Array<ProductControllerSearchV2SourcesEnum>, limit?: number, cursor?: string, sortBy?: ProductControllerSearchV2SortByEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsResponseV2WithPaginationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerSearchV2(query, categories, brands, models, genders, priceMin, priceMax, ratingMin, currency, includeCustom, selectionId, excludeSelectionIds, sources, limit, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.productControllerSearchV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение детальной информации о продукте
         * @param {ProductApiProductControllerGetProductDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerGetProductDetail(requestParameters: ProductApiProductControllerGetProductDetailRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProductDetailResponseDto> {
            return localVarFp.productControllerGetProductDetail(requestParameters.id, requestParameters.article, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поиск продукта по id внешнего источника
         * @param {ProductApiProductControllerGetProductDetailsByExternalIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerGetProductDetailsByExternalId(requestParameters: ProductApiProductControllerGetProductDetailsByExternalIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductByExternalIdResponseDto> {
            return localVarFp.productControllerGetProductDetailsByExternalId(requestParameters.externalId, requestParameters.source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поиск товаров по фильтрам
         * @param {ProductApiProductControllerSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerSearch(requestParameters: ProductApiProductControllerSearchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProductsResponseWithPaginationDto> {
            return localVarFp.productControllerSearch(requestParameters.query, requestParameters.categories, requestParameters.brands, requestParameters.models, requestParameters.genders, requestParameters.priceMin, requestParameters.priceMax, requestParameters.ratingMin, requestParameters.currency, requestParameters.includeCustom, requestParameters.selectionId, requestParameters.excludeSelectionIds, requestParameters.sources, requestParameters.limit, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Количество товаров по фильтрам
         * @param {ProductApiProductControllerSearchCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerSearchCount(requestParameters: ProductApiProductControllerSearchCountRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchProductsCountResponseDto> {
            return localVarFp.productControllerSearchCount(requestParameters.query, requestParameters.categories, requestParameters.brands, requestParameters.models, requestParameters.genders, requestParameters.priceMin, requestParameters.priceMax, requestParameters.ratingMin, requestParameters.currency, requestParameters.includeCustom, requestParameters.selectionId, requestParameters.excludeSelectionIds, requestParameters.sources, requestParameters.limit, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Поиск товаров по фильтрам V2
         * @param {ProductApiProductControllerSearchV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerSearchV2(requestParameters: ProductApiProductControllerSearchV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProductsResponseV2WithPaginationDto> {
            return localVarFp.productControllerSearchV2(requestParameters.query, requestParameters.categories, requestParameters.brands, requestParameters.models, requestParameters.genders, requestParameters.priceMin, requestParameters.priceMax, requestParameters.ratingMin, requestParameters.currency, requestParameters.includeCustom, requestParameters.selectionId, requestParameters.excludeSelectionIds, requestParameters.sources, requestParameters.limit, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productControllerGetProductDetail operation in ProductApi.
 * @export
 * @interface ProductApiProductControllerGetProductDetailRequest
 */
export interface ProductApiProductControllerGetProductDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductApiProductControllerGetProductDetail
     */
    readonly id?: number

    /**
     * 
     * @type {string}
     * @memberof ProductApiProductControllerGetProductDetail
     */
    readonly article?: string
}

/**
 * Request parameters for productControllerGetProductDetailsByExternalId operation in ProductApi.
 * @export
 * @interface ProductApiProductControllerGetProductDetailsByExternalIdRequest
 */
export interface ProductApiProductControllerGetProductDetailsByExternalIdRequest {
    /**
     * Id товара во внешней системе
     * @type {string}
     * @memberof ProductApiProductControllerGetProductDetailsByExternalId
     */
    readonly externalId: string

    /**
     * Source
     * @type {'DEWU' | 'POIZON' | 'GOAT' | 'SHIHUO'}
     * @memberof ProductApiProductControllerGetProductDetailsByExternalId
     */
    readonly source: ProductControllerGetProductDetailsByExternalIdSourceEnum
}

/**
 * Request parameters for productControllerSearch operation in ProductApi.
 * @export
 * @interface ProductApiProductControllerSearchRequest
 */
export interface ProductApiProductControllerSearchRequest {
    /**
     * Search query string
     * @type {string}
     * @memberof ProductApiProductControllerSearch
     */
    readonly query?: string

    /**
     * Category ID or array of category IDs
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearch
     */
    readonly categories?: Array<number>

    /**
     * Array of brand IDs
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearch
     */
    readonly brands?: Array<number>

    /**
     * Array of model IDs
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearch
     */
    readonly models?: Array<number>

    /**
     * Array of genders
     * @type {Array<'MALE' | 'FEMALE' | 'UNISEX' | 'CHILD' | 'BABY' | 'MIDDLE_CHILD' | 'ELDEST_CHILD'>}
     * @memberof ProductApiProductControllerSearch
     */
    readonly genders?: Array<ProductControllerSearchGendersEnum>

    /**
     * Minimum price
     * @type {number}
     * @memberof ProductApiProductControllerSearch
     */
    readonly priceMin?: number

    /**
     * Maximum price
     * @type {number}
     * @memberof ProductApiProductControllerSearch
     */
    readonly priceMax?: number

    /**
     * Minimum rating
     * @type {number}
     * @memberof ProductApiProductControllerSearch
     */
    readonly ratingMin?: number

    /**
     * Целевая валюта для конвертации цен
     * @type {'RUB' | 'CNY' | 'EUR' | 'USD'}
     * @memberof ProductApiProductControllerSearch
     */
    readonly currency?: ProductControllerSearchCurrencyEnum

    /**
     * Include Custom\&#39;s
     * @type {boolean}
     * @memberof ProductApiProductControllerSearch
     */
    readonly includeCustom?: boolean

    /**
     * 
     * @type {number}
     * @memberof ProductApiProductControllerSearch
     */
    readonly selectionId?: number

    /**
     * Array of product selection IDs to exclude products from search results
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearch
     */
    readonly excludeSelectionIds?: Array<number>

    /**
     * Array of sources
     * @type {Array<'DEWU' | 'POIZON' | 'GOAT' | 'SHIHUO'>}
     * @memberof ProductApiProductControllerSearch
     */
    readonly sources?: Array<ProductControllerSearchSourcesEnum>

    /**
     * Limit results
     * @type {number}
     * @memberof ProductApiProductControllerSearch
     */
    readonly limit?: number

    /**
     * Last elemend id for pagination
     * @type {string}
     * @memberof ProductApiProductControllerSearch
     */
    readonly cursor?: string

    /**
     * Sorting method. release_desc/release_asc — по дате релиза; товары без даты всегда в конце выдачи
     * @type {'relevance' | 'price_asc' | 'price_desc' | 'popularity' | 'newest' | 'release_desc' | 'release_asc'}
     * @memberof ProductApiProductControllerSearch
     */
    readonly sortBy?: ProductControllerSearchSortByEnum
}

/**
 * Request parameters for productControllerSearchCount operation in ProductApi.
 * @export
 * @interface ProductApiProductControllerSearchCountRequest
 */
export interface ProductApiProductControllerSearchCountRequest {
    /**
     * Search query string
     * @type {string}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly query?: string

    /**
     * Category ID or array of category IDs
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly categories?: Array<number>

    /**
     * Array of brand IDs
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly brands?: Array<number>

    /**
     * Array of model IDs
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly models?: Array<number>

    /**
     * Array of genders
     * @type {Array<'MALE' | 'FEMALE' | 'UNISEX' | 'CHILD' | 'BABY' | 'MIDDLE_CHILD' | 'ELDEST_CHILD'>}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly genders?: Array<ProductControllerSearchCountGendersEnum>

    /**
     * Minimum price
     * @type {number}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly priceMin?: number

    /**
     * Maximum price
     * @type {number}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly priceMax?: number

    /**
     * Minimum rating
     * @type {number}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly ratingMin?: number

    /**
     * Целевая валюта для конвертации цен
     * @type {'RUB' | 'CNY' | 'EUR' | 'USD'}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly currency?: ProductControllerSearchCountCurrencyEnum

    /**
     * Include Custom\&#39;s
     * @type {boolean}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly includeCustom?: boolean

    /**
     * 
     * @type {number}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly selectionId?: number

    /**
     * Array of product selection IDs to exclude products from search results
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly excludeSelectionIds?: Array<number>

    /**
     * Array of sources
     * @type {Array<'DEWU' | 'POIZON' | 'GOAT' | 'SHIHUO'>}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly sources?: Array<ProductControllerSearchCountSourcesEnum>

    /**
     * Limit results
     * @type {number}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly limit?: number

    /**
     * Last elemend id for pagination
     * @type {string}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly cursor?: string

    /**
     * Sorting method. release_desc/release_asc — по дате релиза; товары без даты всегда в конце выдачи
     * @type {'relevance' | 'price_asc' | 'price_desc' | 'popularity' | 'newest' | 'release_desc' | 'release_asc'}
     * @memberof ProductApiProductControllerSearchCount
     */
    readonly sortBy?: ProductControllerSearchCountSortByEnum
}

/**
 * Request parameters for productControllerSearchV2 operation in ProductApi.
 * @export
 * @interface ProductApiProductControllerSearchV2Request
 */
export interface ProductApiProductControllerSearchV2Request {
    /**
     * Search query string
     * @type {string}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly query?: string

    /**
     * Category ID or array of category IDs
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly categories?: Array<number>

    /**
     * Array of brand IDs
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly brands?: Array<number>

    /**
     * Array of model IDs
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly models?: Array<number>

    /**
     * Array of genders
     * @type {Array<'MALE' | 'FEMALE' | 'UNISEX' | 'CHILD' | 'BABY' | 'MIDDLE_CHILD' | 'ELDEST_CHILD'>}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly genders?: Array<ProductControllerSearchV2GendersEnum>

    /**
     * Minimum price
     * @type {number}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly priceMin?: number

    /**
     * Maximum price
     * @type {number}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly priceMax?: number

    /**
     * Minimum rating
     * @type {number}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly ratingMin?: number

    /**
     * Целевая валюта для конвертации цен
     * @type {'RUB' | 'CNY' | 'EUR' | 'USD'}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly currency?: ProductControllerSearchV2CurrencyEnum

    /**
     * Include Custom\&#39;s
     * @type {boolean}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly includeCustom?: boolean

    /**
     * 
     * @type {number}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly selectionId?: number

    /**
     * Array of product selection IDs to exclude products from search results
     * @type {Array<number>}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly excludeSelectionIds?: Array<number>

    /**
     * Array of sources
     * @type {Array<'DEWU' | 'POIZON' | 'GOAT' | 'SHIHUO'>}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly sources?: Array<ProductControllerSearchV2SourcesEnum>

    /**
     * Limit results
     * @type {number}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly limit?: number

    /**
     * Last elemend id for pagination
     * @type {string}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly cursor?: string

    /**
     * Sorting method. release_desc/release_asc — по дате релиза; товары без даты всегда в конце выдачи
     * @type {'relevance' | 'price_asc' | 'price_desc' | 'popularity' | 'newest' | 'release_desc' | 'release_asc'}
     * @memberof ProductApiProductControllerSearchV2
     */
    readonly sortBy?: ProductControllerSearchV2SortByEnum
}

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * 
     * @summary Получение детальной информации о продукте
     * @param {ProductApiProductControllerGetProductDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productControllerGetProductDetail(requestParameters: ProductApiProductControllerGetProductDetailRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).productControllerGetProductDetail(requestParameters.id, requestParameters.article, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поиск продукта по id внешнего источника
     * @param {ProductApiProductControllerGetProductDetailsByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productControllerGetProductDetailsByExternalId(requestParameters: ProductApiProductControllerGetProductDetailsByExternalIdRequest, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).productControllerGetProductDetailsByExternalId(requestParameters.externalId, requestParameters.source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поиск товаров по фильтрам
     * @param {ProductApiProductControllerSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productControllerSearch(requestParameters: ProductApiProductControllerSearchRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).productControllerSearch(requestParameters.query, requestParameters.categories, requestParameters.brands, requestParameters.models, requestParameters.genders, requestParameters.priceMin, requestParameters.priceMax, requestParameters.ratingMin, requestParameters.currency, requestParameters.includeCustom, requestParameters.selectionId, requestParameters.excludeSelectionIds, requestParameters.sources, requestParameters.limit, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Количество товаров по фильтрам
     * @param {ProductApiProductControllerSearchCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productControllerSearchCount(requestParameters: ProductApiProductControllerSearchCountRequest = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).productControllerSearchCount(requestParameters.query, requestParameters.categories, requestParameters.brands, requestParameters.models, requestParameters.genders, requestParameters.priceMin, requestParameters.priceMax, requestParameters.ratingMin, requestParameters.currency, requestParameters.includeCustom, requestParameters.selectionId, requestParameters.excludeSelectionIds, requestParameters.sources, requestParameters.limit, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Поиск товаров по фильтрам V2
     * @param {ProductApiProductControllerSearchV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productControllerSearchV2(requestParameters: ProductApiProductControllerSearchV2Request = {}, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).productControllerSearchV2(requestParameters.query, requestParameters.categories, requestParameters.brands, requestParameters.models, requestParameters.genders, requestParameters.priceMin, requestParameters.priceMax, requestParameters.ratingMin, requestParameters.currency, requestParameters.includeCustom, requestParameters.selectionId, requestParameters.excludeSelectionIds, requestParameters.sources, requestParameters.limit, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ProductControllerGetProductDetailsByExternalIdSourceEnum = {
    Dewu: 'DEWU',
    Poizon: 'POIZON',
    Goat: 'GOAT',
    Shihuo: 'SHIHUO'
} as const;
export type ProductControllerGetProductDetailsByExternalIdSourceEnum = typeof ProductControllerGetProductDetailsByExternalIdSourceEnum[keyof typeof ProductControllerGetProductDetailsByExternalIdSourceEnum];
/**
 * @export
 */
export const ProductControllerSearchGendersEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unisex: 'UNISEX',
    Child: 'CHILD',
    Baby: 'BABY',
    MiddleChild: 'MIDDLE_CHILD',
    EldestChild: 'ELDEST_CHILD'
} as const;
export type ProductControllerSearchGendersEnum = typeof ProductControllerSearchGendersEnum[keyof typeof ProductControllerSearchGendersEnum];
/**
 * @export
 */
export const ProductControllerSearchCurrencyEnum = {
    Rub: 'RUB',
    Cny: 'CNY',
    Eur: 'EUR',
    Usd: 'USD'
} as const;
export type ProductControllerSearchCurrencyEnum = typeof ProductControllerSearchCurrencyEnum[keyof typeof ProductControllerSearchCurrencyEnum];
/**
 * @export
 */
export const ProductControllerSearchSourcesEnum = {
    Dewu: 'DEWU',
    Poizon: 'POIZON',
    Goat: 'GOAT',
    Shihuo: 'SHIHUO'
} as const;
export type ProductControllerSearchSourcesEnum = typeof ProductControllerSearchSourcesEnum[keyof typeof ProductControllerSearchSourcesEnum];
/**
 * @export
 */
export const ProductControllerSearchSortByEnum = {
    Relevance: 'relevance',
    PriceAsc: 'price_asc',
    PriceDesc: 'price_desc',
    Popularity: 'popularity',
    Newest: 'newest',
    ReleaseDesc: 'release_desc',
    ReleaseAsc: 'release_asc'
} as const;
export type ProductControllerSearchSortByEnum = typeof ProductControllerSearchSortByEnum[keyof typeof ProductControllerSearchSortByEnum];
/**
 * @export
 */
export const ProductControllerSearchCountGendersEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unisex: 'UNISEX',
    Child: 'CHILD',
    Baby: 'BABY',
    MiddleChild: 'MIDDLE_CHILD',
    EldestChild: 'ELDEST_CHILD'
} as const;
export type ProductControllerSearchCountGendersEnum = typeof ProductControllerSearchCountGendersEnum[keyof typeof ProductControllerSearchCountGendersEnum];
/**
 * @export
 */
export const ProductControllerSearchCountCurrencyEnum = {
    Rub: 'RUB',
    Cny: 'CNY',
    Eur: 'EUR',
    Usd: 'USD'
} as const;
export type ProductControllerSearchCountCurrencyEnum = typeof ProductControllerSearchCountCurrencyEnum[keyof typeof ProductControllerSearchCountCurrencyEnum];
/**
 * @export
 */
export const ProductControllerSearchCountSourcesEnum = {
    Dewu: 'DEWU',
    Poizon: 'POIZON',
    Goat: 'GOAT',
    Shihuo: 'SHIHUO'
} as const;
export type ProductControllerSearchCountSourcesEnum = typeof ProductControllerSearchCountSourcesEnum[keyof typeof ProductControllerSearchCountSourcesEnum];
/**
 * @export
 */
export const ProductControllerSearchCountSortByEnum = {
    Relevance: 'relevance',
    PriceAsc: 'price_asc',
    PriceDesc: 'price_desc',
    Popularity: 'popularity',
    Newest: 'newest',
    ReleaseDesc: 'release_desc',
    ReleaseAsc: 'release_asc'
} as const;
export type ProductControllerSearchCountSortByEnum = typeof ProductControllerSearchCountSortByEnum[keyof typeof ProductControllerSearchCountSortByEnum];
/**
 * @export
 */
export const ProductControllerSearchV2GendersEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Unisex: 'UNISEX',
    Child: 'CHILD',
    Baby: 'BABY',
    MiddleChild: 'MIDDLE_CHILD',
    EldestChild: 'ELDEST_CHILD'
} as const;
export type ProductControllerSearchV2GendersEnum = typeof ProductControllerSearchV2GendersEnum[keyof typeof ProductControllerSearchV2GendersEnum];
/**
 * @export
 */
export const ProductControllerSearchV2CurrencyEnum = {
    Rub: 'RUB',
    Cny: 'CNY',
    Eur: 'EUR',
    Usd: 'USD'
} as const;
export type ProductControllerSearchV2CurrencyEnum = typeof ProductControllerSearchV2CurrencyEnum[keyof typeof ProductControllerSearchV2CurrencyEnum];
/**
 * @export
 */
export const ProductControllerSearchV2SourcesEnum = {
    Dewu: 'DEWU',
    Poizon: 'POIZON',
    Goat: 'GOAT',
    Shihuo: 'SHIHUO'
} as const;
export type ProductControllerSearchV2SourcesEnum = typeof ProductControllerSearchV2SourcesEnum[keyof typeof ProductControllerSearchV2SourcesEnum];
/**
 * @export
 */
export const ProductControllerSearchV2SortByEnum = {
    Relevance: 'relevance',
    PriceAsc: 'price_asc',
    PriceDesc: 'price_desc',
    Popularity: 'popularity',
    Newest: 'newest',
    ReleaseDesc: 'release_desc',
    ReleaseAsc: 'release_asc'
} as const;
export type ProductControllerSearchV2SortByEnum = typeof ProductControllerSearchV2SortByEnum[keyof typeof ProductControllerSearchV2SortByEnum];
